import React from 'react';
import {Calendar} from "antd";
import {injectIntl} from "react-intl";
import withAuthorization from "../../../services/Authorization";
import moment from 'moment';
import Constants from "../../../services/Constants";
import ChangeMonthDayStatus from "./ChangeMonthDayStatus";
import connect from "react-redux/es/connect/connect";
import Time from "../../../services/Time";

class MonthConfigurationTab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dayStatusModalOpen: false,
      monthDays: {},
      selectedDayInformation: {}
    }
  };

  onModalDayChange = (day, data) => {
    this.props.updateDay(day, data);
  };

  onSelectDate = (date) => {
    this.setState({
      dayStatusModalOpen: true,
      selectedDayInformation: this.state.monthDays[moment(date).format(Constants.DATE_FORMAT_API)]
    });
  };

  computeCellColor = (day, maxInterventions, dayStatus, amStatus, pmStatus) => {
    const {computeAll} = this.props;
    const totalOngoing = computeAll(moment(day).format(Constants.DATE_FORMAT_API));

    if (Time.beforeToday(day)) {
      return "calendar-box--expired";
    }
    if (dayStatus === Constants.DAY_OVERBOOKED.value && amStatus === Constants.DAY_BLOCK_AM.value && !pmStatus) {
      return "block-am-open-pm";
    }
    if (dayStatus === Constants.DAY_OVERBOOKED.value && !amStatus && pmStatus === Constants.DAY_BLOCK_PM.value) {
      return "open-am-block-pm";
    }
    if (dayStatus === Constants.DAY_MIXED.value && amStatus === Constants.DAY_BLOCK_AM.value && pmStatus === Constants.DAY_CLOSED_PM.value) {
      return "block-am-close-pm";
    }
    if (dayStatus === Constants.DAY_MIXED.value && amStatus === Constants.DAY_CLOSED_AM.value && pmStatus === Constants.DAY_BLOCK_PM.value) {
      return "close-am-block-pm";
    }
    if (dayStatus === Constants.DAY_CLOSED.value && amStatus === Constants.DAY_CLOSED_AM.value && !pmStatus) {
      return "close-am-open-pm";
    }
    if (dayStatus === Constants.DAY_CLOSED.value && !amStatus && pmStatus === Constants.DAY_CLOSED_PM.value) {
      return "open-am-close-pm";
    }
    if (dayStatus && dayStatus === Constants.DAY_CLOSED.value) {
      return "calendar-box--closed";
    }
    if (dayStatus && dayStatus === Constants.DAY_OVERBOOKED.value) {
      return "calendar-box--unavailable";
    }
    return (maxInterventions <= 0) ? "" : (totalOngoing >= maxInterventions) ? "calendar-box--full" : "calendar-box--available";
  };

  getBlockedData = (extendedStatus) => {
    switch (extendedStatus) {
      case Constants.DAY_CONSTRAINT_BLOCK_WAIT_AM.value:
      case Constants.DAY_CONSTRAINT_BLOCK_WAIT_PM.value:
        return 'W';
      case Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_AM.value:
      case Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_PM.value:
        return 'N-W';
      default:
        return null
    }
  }

  updateMonthDays = (day, maxInterventions, nbInterventions, dayStatus, amStatus, pmStatus, amExtendedStatus, pmExtendedStatus) => {
    const {monthDays} = this.state;
    const currentDay = monthDays[day] || {};

    if (currentDay.dayStatus !== dayStatus || currentDay.amStatus !== amStatus || currentDay.pmStatus !== pmStatus || currentDay.amExtendedStatus !== amExtendedStatus || currentDay.pmExtendedStatus !== pmExtendedStatus || currentDay.nbInterventions !== nbInterventions || currentDay.maxInterventions !== maxInterventions) {
      monthDays[day] = {day, maxInterventions, nbInterventions, dayStatus, amStatus, pmStatus, amExtendedStatus, pmExtendedStatus};
      this.setState({monthDays})
    }
  };

  dateFullCellRender = (day) => {
    const {data={}, maxByWeekDay={}} = this.props;
    const currentWeekDay = Time.dayOfWeekAsStringUppercase(day);

    const dataForDay = data[moment(day).format(Constants.DATE_FORMAT_API)] || {};

    const currentDay = moment(day).format("D");
    const maxInterventions = maxByWeekDay[currentWeekDay] || 0;
    const interventionsForDay = (Object.keys(dataForDay).length > 0) ? dataForDay.currentInterventions : 0;

    const colorClass = this.computeCellColor(day, maxInterventions, dataForDay.dayStatus, dataForDay.amStatus, dataForDay.pmStatus);
    this.updateMonthDays(moment(day).format(Constants.DATE_FORMAT_API), maxInterventions, interventionsForDay, dataForDay.dayStatus, dataForDay.amStatus, dataForDay.pmStatus, dataForDay.amExtendedStatus, dataForDay.pmExtendedStatus);

    return (
      <div className={colorClass + " ant-fullcalendar-date"}>
        <div className="ant-fullcalendar-value"
             style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
          <div className="h4-like">{this.getBlockedData(dataForDay.amExtendedStatus)}</div>
          <div className="h4-like">{currentDay}</div>
        </div>

        {colorClass.length > 0 &&
          <div style={{marginTop: '15%', textAlign: 'center', fontWeight: '500'}}>
            {interventionsForDay} / {maxInterventions}
          </div>
        }
        <div className="ant-fullcalendar-value"
             style={{position: 'absolute', right: 10, bottom: 0}}>
          <div className="h4-like">{this.getBlockedData(dataForDay.pmExtendedStatus)}</div>
        </div>
      </div>
    )
  };

  onCalendarRangeChange = (date) => {
    const {selectedDay} = this.props;
    if (moment(selectedDay).year() !== moment(date).year()) {
      this.props.dispatchFetchMonthlyPlanning(moment(date).format(Constants.DATE_FORMAT_API));
    }
    this.props.updateSelectedDay(date);
  };

  render() {
    const {selectedDay, planning} = this.props;
    return (
      <div>
        <Calendar
          className="calendar--hidden-year"
          onSelect={this.onSelectDate}
          dateFullCellRender={this.dateFullCellRender}
          onPanelChange={this.onCalendarRangeChange}
          value={moment(selectedDay)}
        />
        <ChangeMonthDayStatus
          visible={this.state.dayStatusModalOpen}
          onModalClose={() => this.setState({dayStatusModalOpen: false})}
          onModalDayChange={this.onModalDayChange}
          date={this.state.selectedDayInformation}
          planning={planning}
          computeAll={this.props.computeAll}/>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchMonthlyPlanning: (date) => dispatch({type: 'FETCH_MONTHLY_PLANNING.REQUEST', date})
});

export default connect(
  undefined,
  mapDispatchToProps
)(withAuthorization(injectIntl(MonthConfigurationTab), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/planning/management/MonthConfigurationTab.js